const actions = {
  async GET_DATA({dispatch}){
    await dispatch('aparts/GET_ALL');
    dispatch('tasks/GET_ALL');
    dispatch('common/tasks/UPDATE_UNREAD_MESSAGES', null, {root: true});
  },
  async UPDATE_APARTMENT_DATA({dispatch}){
    dispatch('invoices/GET_ALL');
    dispatch('aparts/GET_LE_INFO');
    dispatch('payments/GET_ALL');
    dispatch('news/UPDATE_DATA');
    dispatch('documents/GET_ALL');
    dispatch('devices/GET_DEVICES_VALUES');
    dispatch('devices/GET_DEVICES_VALUES_RANGE');
  }
};

export default actions;
